import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as Actions from 'state/actions'
import Organisations from './Organisations.component'

const mapStateToProps = state => {
  return {
    organisation: state.organisation.active,
    organisations: state.session.organisations
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onNavigate: route => () => dispatch(Actions.onNavigate(route)),
    selectOrganisation: organisation => dispatch(Actions.selectOrganisation(organisation))
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Organisations))
